import React from "react";
import Header from "../layout/Header";

interface InsightDataSourcesProps {
  onBackClick: () => void;
}

const InsightDataSources: React.FC<InsightDataSourcesProps> = ({
  onBackClick,
}) => {
  return (
    <div>
      <Header
        title="Data Sources"
        titlePosition="center"
        showBackButton
        onBackClick={onBackClick}
      />
    </div>
  );
};

export default InsightDataSources;
